/**
 * Global hover-video sound preference — shared by the Ad Library's
 * HoverVideoCard (canvas-ad-library-view.tsx) and the canvas VideoTile
 * (components/canvas/ImageNode.tsx) so one speaker click flips every
 * hover-playing video in the app.
 *
 * Default ON: by the time any hover-video surface is reachable the user has
 * clicked at least once (navigation), which satisfies Chrome's gesture
 * requirement for unmuted playback in practice. Callers still need a
 * NotAllowedError → muted fallback for the cold-start edge.
 * Storage format: '1' | '0' under 'admoji_hover_sound' (v5.15 convention).
 */
const HOVER_SOUND_STORAGE_KEY = 'admoji_hover_sound';

let enabled: boolean = (() => {
  try {
    const stored = localStorage.getItem(HOVER_SOUND_STORAGE_KEY);
    return stored === null ? true : stored === '1';
  } catch {
    return true;
  }
})();

export function isHoverSoundEnabled(): boolean {
  return enabled;
}

export function setHoverSoundEnabled(on: boolean): void {
  enabled = on;
  try {
    localStorage.setItem(HOVER_SOUND_STORAGE_KEY, on ? '1' : '0');
  } catch {
    /* private mode — session-only preference */
  }
}
